// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body{
  font-size: 14px;
}
.embedded-warning{
  margin: 0px 0 -12px 0;
  max-width: 475px;
}
.embedded-warning.patience{
  margin-top: 12px;
}
.input-label.patience{
  margin-top: 20px;
  margin-bottom: -5px;
}
input.form-control.form-control-inline.patience{
  margin-right: 0px;
}
.inline-input {
  padding-left: 5px;
}

::ng-deep .breeze .popover-tooltip{
  max-width: 260px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/plan-settings-dialog/plan-settings-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal-body{\n  font-size: 14px;\n}\n.embedded-warning{\n  margin: 0px 0 -12px 0;\n  max-width: 475px;\n}\n.embedded-warning.patience{\n  margin-top: 12px;\n}\n.input-label.patience{\n  margin-top: 20px;\n  margin-bottom: -5px;\n}\ninput.form-control.form-control-inline.patience{\n  margin-right: 0px;\n}\n.inline-input {\n  padding-left: 5px;\n}\n\n::ng-deep .breeze .popover-tooltip{\n  max-width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
